module.exports = __webpack_public_path__ + "static/media/wellportal.ea4f41d8.png";